export default "__VITE_ASSET__CbPL2mUk__"